import React from "react";
import * as THREE from "three";
import { Viewer } from "@treegram/viewer-core";
import { ModelingMeasureRepresentation, ModelingType } from "./modeling-tools-context-provider.tsx";

export interface ModelingToolsContextProps {
    initialiseViewer: (viewer: Viewer) => void;

    isInDrawingMode: boolean;
    setIsInDrawingMode: (isDrawing: boolean) => void;

    isInEditingMode: boolean,
    setIsInEditingMode: (isEditing: boolean) => void,

    isCurrentlyDrawing: () => boolean;

    drawingType: ModelingType;
    setDrawingType: (type: ModelingType) => void;

    drawingMeasureRepresentation: ModelingMeasureRepresentation;
    setDrawingMeasureRepresentation: (measureRepresentation: ModelingMeasureRepresentation) => void;

    drawingColor: THREE.Color,
    setDrawingColor: (drawingColor: THREE.Color) => void;

    drawingAlpha: number;
    setDrawingAlpha: (alpha: number) => void;

    drawingDataInformations: Record<string, unknown> | undefined;
    setDrawingDataInformations: (dataInformations: Record<string, unknown> | undefined) => void;

    editingType: ModelingType;
    setEditingType: (type: ModelingType) => void;

    editingMeasureRepresentation: ModelingMeasureRepresentation;
    setEditingMeasureRepresentation: (measureRepresentation: ModelingMeasureRepresentation) => void;

    editingColor: THREE.Color,
    setEditingColor: (color: THREE.Color) => void;

    editingAlpha: number;
    setEditingAlpha: (alpha: number) => void;

    editingDataInformations: Record<string, unknown> | undefined;
    setEditingDataInformations: (dataInformations: Record<string, unknown> | undefined) => void;

    editingPoints: THREE.Vector3[];
    setEditingPoints: (points: THREE.Vector3[]) => void;
}

export const ModelingToolsContext = React.createContext<ModelingToolsContextProps | undefined>(undefined);